// extracted by mini-css-extract-plugin
export var container = "Trf5C12l";
export var borderContainer = "uJmmtyHB";
export var fieldContainer = "tCYdNcAs";
export var title = "pq4cq69j";
export var flexDivider = "YzMMx19k";
export var link = "aq90IR3U";
export var data = "ZzWZZNs9";